export class NoFileError extends Error{
  constructor(message: string){
    super(message)
    this.name = 'NoFileError'
  }
}